import { render, staticRenderFns } from "./CreateCampaignSetupsStep.vue?vue&type=template&id=186849f3&scoped=true"
import script from "./CreateCampaignSetupsStep.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSetupsStep.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignSetupsStep.vue?vue&type=style&index=0&id=186849f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186849f3",
  null
  
)

export default component.exports